import { Component, EventEmitter, Input, Output } from '@angular/core';

export type GenericModalSaveType = 'submit' | 'button';

@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.scss']
})
export class GenericModalComponent {
  /** Clave de localización del título del modal (se resuelve internamente con `| localize`). */
  @Input() title: string = '';
  /** Si el título ya viene resuelto (ej. compuesto con datos dinámicos), evita aplicarle `| localize` de nuevo. */
  @Input() titleAlreadyLocalized: boolean = false;

  @Input() saving: boolean = false;
  @Input() saveDisabled: boolean = false;

  @Input() showFooter: boolean = true;
  @Input() showCancelButton: boolean = true;
  @Input() showSaveButton: boolean = true;

  /** Claves de localización, se resuelven internamente. */
  @Input() cancelLabel: string = 'Cancel';
  @Input() saveLabel: string = 'Save';

  /** 'submit' (default) dispara el (ngSubmit) del <form> ancestro; 'button' solo emite (save). */
  @Input() saveType: GenericModalSaveType = 'submit';

  @Output() cancel = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();

  onCancel(): void {
    this.cancel.emit();
  }

  onSave(): void {
    this.save.emit();
  }
}
